import { gql } from '@apollo/client';

import { mediaSession } from '../fragments';

export default gql`
  mutation SetMediaSessionAsSkipped(
    $courseId: String!
    $subjectId: String!
    $mediaItemId: String!
    $mediaSessionId: String!
    $input: SetMediaSessionAsSkippedInput!
  ) {
    mediaSession(
      courseId: $courseId
      subjectId: $subjectId
      mediaItemId: $mediaItemId
      mediaSessionId: $mediaSessionId
      input: $input
    )
      @rest(
        type: "MediaSession"
        path: "courses/{args.courseId}/subjects/{args.subjectId}/videos/{args.mediaItemId}/sessions/{args.mediaSessionId}/set-as-skipped"
        method: "PUT"
      ) {
      ...MediaSession
    }
  }
  ${mediaSession}
`;
